import React, { Component } from "react";
import { string, bool, oneOf } from "prop-types";
import classNames from "classnames";
import { AvatarSize } from "./avatar.types";

export class Avatar extends Component {
  componentDidMount() {
    this.props.getRef && this.props.getRef(this.buttonRef);
  }

  render() {
    const {
      id,
      ariaLabel,
      ariaDescribedby,
      children,
      className,
      image,
      light,
      size,
      text,
    } = this.props;

    const avatarClasses = classNames(
      "spark-avatar",
      { [`spark-avatar--${size}`]: size },
      { "spark-avatar--text": text },
      { "spark-avatar--image": image },
      { "spark-avatar--light": light },
      className
    );

    return (
      <span
        className={avatarClasses}
        ref={(node) => (this.buttonRef = node)}
        onClick={this.props.onClick}
        id={id}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedby}
      >
        {children}
      </span>
    );
  }
}

// Backwards compatibility to support component property. Enum import should be used instead.
Avatar.SIZE = AvatarSize;

Avatar.propTypes = {
  /** For accessibility when child component is passed to avatar */
  ariaDescribedby: string,

  /** Id for avatar */
  id: string,

  /** For avatar accessibility */
  ariaLabel: string,

  /** Any extra CSS classes for the component */
  className: string,

  /** Adds class for non-text avatars */
  image: bool,

  /** A lighter theme for the neutral color scheme. */
  light: bool,

  /** Determines size Avatar will render: sm, md, lg, xl */
  size: oneOf(Object.values(AvatarSize)),

  /** Adds class for non-image avatars */
  text: bool,

  /** HTML `type` attribute. Wrap spans with anchor tags */
  type: oneOf(["span", "a"]),
};

Avatar.displayName = "Avatar";
